import { initializeApp } from "firebase/app";



const firebaseConfig = {
    apiKey: "AIzaSyDqoly2XRitkZiAte08ip0AfgmBWUCeIbI",
    authDomain: "quizwall-91b63.firebaseapp.com",
    projectId: "quizwall-91b63",
    storageBucket: "quizwall-91b63.appspot.com",
    messagingSenderId: "153773273368",
    appId: "1:153773273368:web:825976a1eb9e8081466e6d",
    measurementId: "G-3DGMCH54NH"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);



